import styled from 'styled-components';

export const StyledMitreTagsContainer = styled.div`
  border-right: 0.1rem solid ${({ theme }) => theme.colors.border.light};
  padding-right: 1.6rem;
  margin-right: 1.6rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    border-bottom: 0.1rem solid ${({ theme }) => theme.colors.border.light};
    border-right: 0;
    padding-right: 0;
    margin-right: 0;

    padding-bottom: 1.6rem;
    margin-bottom: 1.6rem;
  }
`;

export const StyledRoomCategoryWrapper = styled.div`
  margin-top: 3.2rem;
  min-height: 58.3rem;
  max-height: 58.3rem;
  height: 100%;
  overflow-y: scroll;
  padding-right: 0.5rem;
`;
